import React, { useEffect, useState } from "react";
import { Card, Descriptions, Button, Form, Input, Spin, message } from "antd";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FinanceService from "Services/FinanceService";

// Finance profile view + edit (Points 7 & 8). Separate from the employee profile.
const FinanceProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const load = async () => {
    try {
      setLoading(true);
      const data = await FinanceService.getProfile();
      setProfile(data || null);
    } catch (e) {
      console.error("Failed to load finance profile", e);
      message.error("Failed to load profile");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const startEdit = () => {
    form.setFieldsValue({
      firstName: profile?.firstName,
      lastName: profile?.lastName,
      phoneNo: profile?.phoneNo,
      country: profile?.country,
      state: profile?.state,
      city: profile?.city,
    });
    setEditing(true);
  };

  const onSave = async (values) => {
    try {
      setSaving(true);
      const updated = await FinanceService.updateProfile({
        ...values,
        profileImage: profile?.profileImage ?? null,
      });
      setProfile(updated || { ...profile, ...values });
      setEditing(false);
      message.success("Profile updated");
    } catch (e) {
      message.error(e.response?.data?.details || "Failed to update profile");
    } finally {
      setSaving(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card
        title="Finance Profile"
        className="card-professional"
        style={{ margin: 16 }}
        extra={
          !editing && !loading ? (
            <Button className="btn-primary" onClick={startEdit}>
              Edit
            </Button>
          ) : null
        }
      >
        {loading ? (
          <Spin />
        ) : editing ? (
          <Form form={form} layout="vertical" onFinish={onSave}>
            <Form.Item
              name="firstName"
              label="First Name"
              rules={[{ required: true, message: "First name is required" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="lastName"
              label="Last Name"
              rules={[{ required: true, message: "Last name is required" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="phoneNo" label="Phone">
              <Input />
            </Form.Item>
            <Form.Item name="country" label="Country">
              <Input />
            </Form.Item>
            <Form.Item name="state" label="State">
              <Input />
            </Form.Item>
            <Form.Item name="city" label="City">
              <Input />
            </Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="btn-primary"
              loading={saving}
              style={{ marginRight: 8 }}
            >
              Save
            </Button>
            <Button onClick={() => setEditing(false)}>Cancel</Button>
          </Form>
        ) : (
          <Descriptions column={2} bordered size="small">
            <Descriptions.Item label="First Name">{profile?.firstName || "-"}</Descriptions.Item>
            <Descriptions.Item label="Last Name">{profile?.lastName || "-"}</Descriptions.Item>
            <Descriptions.Item label="Email">{profile?.email || "-"}</Descriptions.Item>
            <Descriptions.Item label="Phone">{profile?.phoneNo || "-"}</Descriptions.Item>
            <Descriptions.Item label="Country">{profile?.country || "-"}</Descriptions.Item>
            <Descriptions.Item label="State">{profile?.state || "-"}</Descriptions.Item>
            <Descriptions.Item label="City">{profile?.city || "-"}</Descriptions.Item>
          </Descriptions>
        )}
      </Card>
    </DashboardLayout>
  );
};

export default FinanceProfile;
